module.exports = __webpack_public_path__ + "img/loading.905470c9.gif";